import script from "./UserFavorites.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFavorites.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/UserFavorites.css?vue&type=style&index=0&id=0c81dfb9&scoped=true&lang=css&external"
import "@/features/user/styles/operationArea/OperationAreaTheme.css?vue&type=style&index=1&id=0c81dfb9&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c81dfb9"]])

export default __exports__